import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../providers/login.service';
import { FormControl, Validators } from '@angular/forms';
import { createSession } from '../../common/sessionHandler';
import { ApiPromisefactory } from '../../providers/promise.factory';

/**
     * Displays Login page .         
     */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  userName: string;
  password: string;
  isSpinnerHidden: Boolean = false;
  isLoginBtnHidden: Boolean = true;
  txtLogin: String = 'Login';
  userNameControl: FormControl = new FormControl();
  passwordControl: FormControl = new FormControl();;
  

  constructor(private _loginService: LoginService, private router: Router, private promiseSvc: ApiPromisefactory) { }

  ngOnInit() {
  /**
     * If empty, notifies 'required' error.         
     */
    this.userNameControl = new FormControl('', Validators.required);
    /**
     * If empty, notifies 'required' error.         
     */
    this.passwordControl = new FormControl('', Validators.required);
  }

  userLogin() {
    this.isLoginBtnHidden = false;
    this.isSpinnerHidden = true;
    this.txtLogin = 'Logging in';
    setTimeout(() => {
      createSession();
      this.router.navigate(['/docs']);
    }, 3000);
  }
}
